var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('footer',{staticClass:"footer px-4 mx-2"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row align-items-center justify-content-lg-between"},[_c('ul',{staticClass:"nav nav-footer"}),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"copyright text-center text-lg-right text-muted"})])])
}]

export { render, staticRenderFns }